import { Box } from '@mui/material';
import GoogleMap from '../maps/googlemap/GoogleMap';
import { useAppDispatch, useAppSelector } from '../../../app/redux/hooks';
import { useEffect, useState } from 'react';
import { tripTrackingAction } from '../../../features/yaantrac/redux/reducer/yaantracSlices/tripTrackingSlice';
import { useLocation } from 'react-router-dom';
import CustomDetailedCard from '../customdetailedcard/CustomDetailedCard';
import { tripsAction } from '../../../features/yaantrac/redux/reducer/yaantracSlices/mytripsSlice';
import { convertEpochToDateString } from '../../../utils/commonFunctions';
import GoogleTripDirections from '../maps/googledirection/GoogleTripDirections';
import { decode } from '@googlemaps/polyline-codec';
import { updatePolyline } from '../../../common/redux/reducer/commonSlices/polylineSlice';
import GooglePolyline from '../maps/googlepolyline/GooglePolyline';
import {
  map,
  updateCenter,
  updateZoom
} from '../../../common/redux/reducer/commonSlices/mapSlice';
import {
  createConnection,
  updateData
} from '../../../common/redux/reducer/commonSlices/websocketSlice';

interface Trip {
  code: string;
  destination: string;
  driverID: string;
  driverName: string;
  encodedPolyline: string;
  endGeoZoneColor: string;
  endGeoZoneRadius: number;
  endLatitude: number;
  endLongitude: number;
  endTime: number;
  id: number;
  isActive: number;
  notificationStatus: number;
  source: string;
  startGeoZoneColor: string;
  startGeoZoneRadius: number;
  startLatitude: number;
  startLongitude: number;
  startTime: number;
  tripID: number;
  tripPathLatAndLngDetails: any;
  tripStatus: string;
  userID: string;
  vehicleNumber: string;
  waypointDetails: any[];
}

interface TripsState {
  data: Trip[];
}

const TripTracking = () => {
  const [filteredData, setFilteredData] = useState<Trip>();

  const dispatch = useAppDispatch();
  const location = useLocation();

  //APIs
  const tripsData: TripsState = useAppSelector(state => state.trips);
  const tripsTrckingData = useAppSelector(state => state.tripTrackingSlice);
  const { connection, data } = useAppSelector(state => state.websocket);
  const { paths } = useAppSelector(state => state.polyline);

  console.log('tripsTrckingData', tripsTrckingData);

  let tripId: any = 0;
  const search = location.search;

  if (search.includes(':')) {
    const params = new URLSearchParams(search.replace(/:/g, '='));
    tripId = params.get('tripId');
  } else {
    const queryParams = new URLSearchParams(search);
    tripId = queryParams.get('tripId');
  }

  const waypoints =
    filteredData?.waypointDetails?.map((value: any, index: number) => ({
      id: index + 1,
      name: 'waypoint',
      lat: value.waypointLat,
      lng: value.waypointLng,
      info: { Mylocation: `Waypoint ${index + 1}` },
      dAddress: value.waypointAddress
    })) || [];

  const locationData: any = [
    {
      id: 'source',
      name: 'trips',
      lat: filteredData?.startLatitude,
      lng: filteredData?.startLongitude,
      info: {
        Mylocation:
          filteredData?.vehicleNumber && filteredData?.vehicleNumber.toUpperCase(),
        heading: 'Started at :',
        Time: filteredData?.startTime && convertEpochToDateString(filteredData?.startTime)
      }
    },
    ...waypoints,
    {
      id: 'destination',
      name: 'trips',
      lat: filteredData?.endLatitude,
      lng: filteredData?.endLongitude,
      info: {
        Mylocation:
          filteredData?.vehicleNumber && filteredData?.vehicleNumber.toUpperCase(),
        heading: 'Expected arrival :',
        Time: filteredData?.endTime && convertEpochToDateString(filteredData?.endTime)
      }
    }
  ];

  useEffect(() => {
    if (connection) {
      connection.onopen = () => {
        console.log('vehicle connected');
      };

      connection.onmessage = (e: any) => {
        dispatch(updateData(JSON.parse(e?.data)));
      };

      connection.onclose = () => {
        console.log('connection closed');
      };
    }

    return () => {
      if (connection) connection.close();
    };
  }, [connection]);

  useEffect(() => {
    // dispatch(tripTrackingAction({ tripId: tripId }));
    dispatch(tripsAction());
  }, [tripId]);

  useEffect(() => {
    if (tripsData.data.length > 0) {
      const [filteredData] = tripsData.data.filter((item: any) => {
        if (tripId !== null) return item.tripID == tripId;
      });
      if (filteredData?.vehicleNumber)
        dispatch(createConnection(filteredData?.vehicleNumber));
      const decoded = decode(filteredData?.encodedPolyline)?.map(([lat, lng]) => ({
        lat,
        lng
      }));
      dispatch(updatePolyline(decoded));
      dispatch(updateZoom(decoded));
      dispatch(updateCenter(decoded));
      setFilteredData(filteredData);
    }
  }, [tripsData.data]);

  useEffect(() => {
    if (data && [data].length > 0) {
      const [filteredMarker]: any = tripsData.data?.filter((value: any) => {
        return value.vehicleNumber === (data as { vehicle_number: any }).vehicle_number;
      });
      const convertedData = [data].map((item: any) => ({
        id: item.vehicle_number,
        lat: parseFloat(item.latitude),
        lng: parseFloat(item.longitude),
        type: filteredMarker?.type,
        name: filteredMarker?.type,
        status: item.vehicle_status,
        info: {
          speed: `${item.speed} kmph`,
          todayDistance: filteredMarker?.info?.todayDistance,
          totalDistance: `${item.total_distance} KM`,
          driverName: filteredMarker?.info?.driverName,
          driverContactNo: filteredMarker?.info?.driverContactNo
        }
      }));
      if (filteredMarker?.vehicleNumber === (data as any)?.vehicle_number) {
        dispatch(map(convertedData));
      }
    }
  }, [data, tripsData.data]);

  return (
    <Box sx={{ width: '100%', height: '100vh' }}>
      {paths.length === 0 && (
        <Box className='cs-loader' sx={{ zIndex: '10' }}>
          <Box className='cs-loader-inner'>
            <label>●</label>
            <label>●</label>
            <label>●</label>
            <label>●</label>
          </Box>
        </Box>
      )}
      <GoogleMap>
        {[filteredData]?.length > 0 && (
          <>
            <CustomDetailedCard rowData={filteredData} showActivate={false} />
            <GoogleTripDirections
              origin={{
                lat: filteredData?.startLatitude ?? 0,
                lng: filteredData?.startLongitude ?? 0
              }}
              destination={{
                lat: filteredData?.endLatitude ?? 0,
                lng: filteredData?.endLongitude ?? 0
              }}
              locations={locationData}
            />
          </>
        )}
        {paths?.length > 0 && <GooglePolyline />}
      </GoogleMap>
    </Box>
  );
};

export default TripTracking;
